import { FunctionalComponent, h } from 'preact';

import { Gallery2TemplatePropsInterface } from 'common/module/gallery-2/template-props.interface';

/**
 * Gallery template
 */
export const Gallery2Template: FunctionalComponent<Gallery2TemplatePropsInterface> = (props) => (
  <div
    className={`gallery ${props.className || ''}`}
    onTouchStart={props.onTouchStart}
    onMouseDown={props.onMouseDown}
    onClick={props.onClick}
    ref={props.onGalleryRef}
  >
    {props.children}
  </div>
);
